import {
  IMPORT_DATA_CLEAR,
  IMPORT_DATA_INIT_WORKER,
  IMPORT_DATA_SET_CURRENT_STEP,
  IMPORT_DATA_SET_DETECT_BACK_STEP,
  IMPORT_DATA_SET_FILE_DATA,
  IMPORT_DATA_SET_IMPORT_CONFIG,
  IMPORT_DATA_SET_INFO_DATA,
  IMPORT_DATA_SET_OUTPUT_CONFIG,
  IMPORT_DATA_SET_WORKER_STATUS,
  IMPORT_DATA_UPDATE_PROGRESS,
  IMPORT_DATA_UPDATE_UPLOAD_STATUS,
  IMPORT_DATA_UPDATE_TABLE_DATA,
  IMPORT_DATA_SET_GROUP_DATA,
  IMPORT_DATA_SET_IMPORT_CONFIG_GROUP_RAW_DATA,
  IMPORT_DATA_SET_IMPORT_CONFIG_GROUPS,
  IMPORT_DATA_SET_SELECTED_TEMPLATE_ID,
  IMPORT_DATA_FETCH_ALL_TEMPLATES_START,
  IMPORT_DATA_FETCH_ALL_TEMPLATES_SUCCESS,
  IMPORT_DATA_TEMPLATE_OPERATION_FAIL,
  IMPORT_DATA_SET_ERROR,
  IMPORT_DATA_SET_TEMPLATE_SAVE_BLOCK,
  IMPORT_DATA_DELETE_TEMPLATE_SUCCESS,
  IMPORT_DATA_SET_IMPORT_WITH_TEMPLATES_STATUS,
  IMPORT_DATA_SET_XML_TEMPLATE_CONFIG,
  IMPORT_DATA_SET_XML_PARSED_DATA,
  IMPORT_DATA_SET_XML_DATA,
  IMPORT_DATA_SET_FILES,
  IMPORT_DATA_SET_ADDITIONAL_FILES,
  IMPORT_DATA_SET_XML_STRUCTURE,
  IMPORT_DATA_SET_EDITING_TEMPLATE
} from './action';
import { ImportTypes } from '@constants/types/import-types.constants';
import update from 'immutability-helper';

const initialState = {
  worker: undefined,
  // дополнительные файловые данные
  fData: {},
  // массив основных файлов, из которых мы формируем импорт
  files: [],
  // массив доп. файлов, которые добавляются к атрибутам
  additionalFiles: [],
  // описание структуры, полученное с бэка
  infoData: {
    updatedKey: undefined,
    data: []
  },
  tableData: new Map(),
  // настройки импорта
  importConfig: {
    // ссылка на первый набор данных (нужна для извлечения файлов)
    firstFileKey: undefined,
    // ссылка на первый набор, который был первым до драгга (нужен для извлечения файлов на бэке)
    unDraggedFirstFileKey: undefined,
    // схема для набора атрибутов
    schema: {},
    // данные колонок
    columnData: {},
    // данные файлов
    files: {},
    // данные групп (если задан categoryId, то группы будут созданы внутри этой категории)
    groups: {},
    // конфигурация типов датафреймов для импорта заказов
    ordersConfig: {
      // ссылка на наборы с данными заказов
      dfOrderId: [],
      // ссылка на наборы с данными заказов и товаров
      dfProductId: [],
      // ссылка на наборы с данными платежей
      dfPaymentId: [],
      // ид выбранного из paymentAccountIds идентификатора платежного акаунта
      paymentAccountId: null,
      // ссылка на ид выбранного хранилища заказов
      orderStorageId: null,
      // массив индентификаторов, используемых хранилищем заказов платежных аккаунтов
      paymentAccountIds: []
    },
    // конфигурация для импорта данных форм
    formDataConfig: {
      formId: null,
      moduleId: null,
    },
    // признак обработки всех наборов данных, а не только мастер-таблицы
    // processAllDataframes: false,
    // сколько записей доступно для обработки
    includeOnlyFirstRecords: 20,
    // ид выбранной категории
    categoryId: null,
    // собирать категории из имени товаров
    isProductNameCategory: false,
    // признак, что в корне файловой системы не одна папка
    noRootDir: false,
  },
  // настройки предпросмотра данных для импорта
  outputConfig: {
    skipRows: 0,
    outputRows: 5,
    type: ImportTypes.xmlFiles,
    // имя колонок, которые надо клонировать
    clonedColumnNames: [],
    // dbType: 'mysql', // null,
    // dbConString: 'wp_user:wp_password@172.17.0.1:3306/wordpress_woocommerce', // null,
    // конфигурации для pivot таблиц
    // pivotConfig: {},
    // ключ главного набора данных (для xml импорта)
    mainDataSetIndex: 0
  },
  xml: {
    structure: [],
    parsedData: [],
    data: [],
    // для данных, полученных после обработки на шаге 1
    groupFoundData: [],
    templateConfig: []
  },
  currentStep: 0,
  failedData: [],
  isRunningWorker: false,
  backStepDetected: false,
  progress: 0,
  uploadStatus: null,
  templates: [],
  selectedTemplateId: null,
  isLoadingTemplates: false,
  isRunningImportWithTemplates: false,
  blockSavingTemplate: false,
  // режим редактирования выбранного шаблона (только excel/csv)
  isEditingTemplate: false,
  // числовой id редактируемого шаблона (для PUT-обновления)
  editingTemplateId: null,
  processingError: ''
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case IMPORT_DATA_INIT_WORKER:
    return {
      ...state,
      worker: payload,
    };

  case IMPORT_DATA_SET_WORKER_STATUS:
    return {
      ...state,
      isRunningWorker: payload,
    };

  case IMPORT_DATA_CLEAR:
    return {
      ...initialState,
    };

  case IMPORT_DATA_SET_FILES:
    return {
      ...state,
      files: payload,
    };

  case IMPORT_DATA_SET_XML_STRUCTURE:
    return {
      ...state,
      xml: {
        ...state.xml,
        structure: payload,
      }
    };

  case IMPORT_DATA_SET_ADDITIONAL_FILES:
    return {
      ...state,
      additionalFiles: payload,
    };

  case IMPORT_DATA_SET_CURRENT_STEP:
    return {
      ...state,
      currentStep: payload
    };

  case IMPORT_DATA_SET_DETECT_BACK_STEP:
    return {
      ...state,
      backStepDetected: payload
    };

  case IMPORT_DATA_UPDATE_TABLE_DATA:
    return {
      ...state,
      tableData: new Map(payload)
    };

  case IMPORT_DATA_SET_XML_DATA:
    return {
      ...state,
      xml: {
        ...state.xml,
        data: Array.isArray(payload)
          ? []
          : update(state.xml.data, {
            [payload.index]: { $set: payload.data }
          })
      }
    };

  case IMPORT_DATA_SET_INFO_DATA:
    return {
      ...state,
      importConfig: {
        ...state.importConfig,
        // делаем это только один раз!
        // @deprecated ?
        unDraggedFirstFileKey: state.importConfig.unDraggedFirstFileKey === undefined
          ? payload.data[0].fileKey
          : state.importConfig.unDraggedFirstFileKey
      },
      infoData: {
        ...state.infoData,
        updatedKey: payload?.updatedKey,
        data: payload?.updatedKey
          // eslint-disable-next-line
          ? state.infoData.data.map((item) => item.fileKey === payload.updatedKey ? ({ ...payload.data, position: item.position }) : item)
          : payload.data.map((item, index) => ({ ...item, position: index + 1 })), // init
      }
    };

  case IMPORT_DATA_SET_OUTPUT_CONFIG:
    return {
      ...state,
      outputConfig: payload
    };

  case IMPORT_DATA_SET_IMPORT_CONFIG:
    return {
      ...state,
      importConfig: payload,
    };

  case IMPORT_DATA_UPDATE_PROGRESS:
    return {
      ...state,
      progress: payload,
    };

  case IMPORT_DATA_UPDATE_UPLOAD_STATUS:
    return {
      ...state,
      uploadStatus: payload,
    };

  case IMPORT_DATA_SET_IMPORT_CONFIG_GROUP_RAW_DATA:
    return {
      ...state,
      importConfig: {
        ...state.importConfig,
        groups: {
          ...state.importConfig.groups,
          rawData: update(state.importConfig.groups?.rawData || [], {
            [payload.index]: { $set: payload.data }
          })
        }
      }
    };

  case IMPORT_DATA_SET_GROUP_DATA:
    return {
      ...state,
      xml: {
        ...state.xml,
        groupFoundData: Array.isArray(payload)
          ? []
          : update(state.xml.groupFoundData, {
            [payload.index]: { $set: payload.data }
          })
      }
    };

  case IMPORT_DATA_SET_FILE_DATA:
    return {
      ...state,
      fsData: payload,
    };

  case IMPORT_DATA_SET_IMPORT_CONFIG_GROUPS:
    // перелинковывыем группы (связываем их с файловыми ключами)
    const flatGroups = state.importConfig.groups?.rawData
      ? state.importConfig.groups.rawData.flatMap((d) => (Array.isArray(d) ? d.map((item) => item) : d))
      : [];
    const groups = {};
    if (flatGroups.length > 0) {
      payload.forEach((item, index) => {
        groups[item.fileKey] = {
          index,
          value: flatGroups?.[index] !== undefined
            ? (typeof flatGroups?.[index] === 'object' ? index : flatGroups?.[index])
            : index,
          position: index,
        };
      });
    }

    return {
      ...state,
      importConfig: {
        ...state.importConfig,
        groups: Object.keys(groups).length
          ? update(state.importConfig.groups, { $set: groups })
          : update(state.importConfig.groups, { $set: payload }),
        // ссылка на первый набор (файл)
        firstFileKey: Object.keys(groups).length
          ? Object.keys(groups)[0]
          : Object.keys(payload).find((key) => payload[key]?.position === 0) || payload[0]?.fileKey || ''
      }
    };

  case IMPORT_DATA_SET_SELECTED_TEMPLATE_ID:
    return {
      ...state,
      selectedTemplateId: payload
    };

  case IMPORT_DATA_SET_IMPORT_WITH_TEMPLATES_STATUS:
    return {
      ...state,
      isRunningImportWithTemplates: payload,
    };

  case IMPORT_DATA_FETCH_ALL_TEMPLATES_START:
    return {
      ...state,
      isLoadingTemplates: true
    };

  case IMPORT_DATA_FETCH_ALL_TEMPLATES_SUCCESS:
    return {
      ...state,
      isLoadingTemplates: false,
      templates: payload || []
    };

  case IMPORT_DATA_TEMPLATE_OPERATION_FAIL:
    return {
      ...state,
      isLoadingTemplates: false,
      importError: payload?.response?.data?.message || payload?.message || String(payload) || null,
    };

  case IMPORT_DATA_DELETE_TEMPLATE_SUCCESS:
    return {
      ...state,
      selectedTemplate: {}
    };

  case IMPORT_DATA_SET_ERROR:
    return {
      ...state,
      importError: payload?.response?.data?.message || payload?.message || String(payload) || null,
      isRunningWorker: false
    };

  case IMPORT_DATA_SET_XML_TEMPLATE_CONFIG:
    return {
      ...state,
      xml: {
        ...state.xml,
        templateConfig: Array.isArray(payload)
          ? []
          : update(state.xml.templateConfig, {
            [payload.index]: {
              $apply: (templateConfigItem) => {
                if (!templateConfigItem) {
                  templateConfigItem = {};
                }
                // Update or add the key with the new value
                return update(templateConfigItem, {
                  [payload.key]: { $set: payload.value }
                });
              }
            }
          })
      }
    };

  case IMPORT_DATA_SET_XML_PARSED_DATA:
    return {
      ...state,
      xml: {
        ...state.xml,
        parsedData: Array.isArray(payload)
          ? []
          : update(state.xml.parsedData, {
            [payload.index]: { $set: payload.data }
          })
      }
    };

  case IMPORT_DATA_SET_TEMPLATE_SAVE_BLOCK:
    return {
      ...state,
      blockSavingTemplate: payload
    };

  case IMPORT_DATA_SET_EDITING_TEMPLATE:
    return {
      ...state,
      isEditingTemplate: !!payload?.isEditing,
      editingTemplateId: payload?.isEditing ? (payload.id ?? null) : null
    };

  default:
    return { ...state };
  }
};
